import { t } from 'i18next';
import { LitElement, PropertyValueMap, html } from 'lit';
import { customElement, property } from 'lit/decorators.js';

import { StepEnum, VersionStepDto } from '@/api-sdk';

import { isScrolledIntoView, scrollStepIntoView } from '@/utils';

import '../fg-configurator-step';
import './color-version/fg-version-options-list';

@customElement('fg-configurator-step-version')
export class FgConfiguratorStepVersion extends LitElement {
  @property({ type: Array })
  versions: VersionStepDto['versions'] = [];

  @property({ type: String })
  stepType?: StepEnum;

  @property({ type: Boolean })
  scrollToStep = false;

  render() {
    return html`
      <fg-configurator-step
        .stepTitle=${t('headers.chooseProduct')}
        .stepType=${this.stepType}
      >
        <fg-version-options-list
          .options=${this.versions}
        ></fg-version-options-list>
      </fg-configurator-step>
    `;
  }

  protected willUpdate(
    _changedProperties: PropertyValueMap<any> | Map<PropertyKey, unknown>,
  ): void {
    if (_changedProperties.has('scrollToStep') && this.scrollToStep) {
      scrollStepIntoView(this);
      isScrolledIntoView(this);
    }
  }
}
